import React from 'react';
import { graphql } from 'gatsby';
import SvgSafeGatsbyImage from '@atoms/SvgSafeGatsbyImage';
import Container from '@atoms/Container';
import DotImage from '../../images/dot-pattern.svg';
import Accordion from '@atoms/styled-accordion';
import RichTextEditorStyles from '@utils/RichTextEditorStyles';
import paddingDefault from '@utils/paddingDefault';
import { StyledButtonAsLink } from '../primitives/styled-button';

const MediacontentFaqs = ({ data }) => {
    const { mediacontent, faqs } = data;
    const { link } = faqs;
    /* eslint-disable-next-line no-unused-vars */
    const { content, image, disable_background_dots } = mediacontent;

    const hasImage = !!image?.url;

    return (
        <Container>
            <div css={[paddingDefault(), styles.containerInnerWrap]}>
                <div css={styles.contentWrap}>
                    <div css={styles.richTextWrap}>
                        {content && (
                            <div
                                css={[RichTextEditorStyles, styles.richText]}
                                dangerouslySetInnerHTML={{ __html: content }}
                            />
                        )}
                    </div>
                    {hasImage && (
                        <div css={styles.imageWrapper}>
                            <SvgSafeGatsbyImage
                                css={styles.image}
                                image={image}
                                alt={image.description}
                            />
                            {!disable_background_dots && <DotImage css={styles.dotPattern} />}
                        </div>
                    )}
                </div>
                <div css={styles.accordionWrap}>
                    <Accordion faqs={faqs} onMediaContent />
                    {!!link?.href && (
                        <div css={styles.buttonWrap}>
                            <StyledButtonAsLink to={link.href}>{link.title}</StyledButtonAsLink>
                        </div>
                    )}
                </div>
            </div>
        </Container>
    );
};

const styles = {
    containerInnerWrap: {
        "@media (min-width: 1024px)": {
            display: "flex",
            flexDirection: "row"
        }
    }
    ,
    richText: {
        color: "#fff",
        "h2, h4, li": { color: "#fff" }
    },
    richTextWrap: {
        paddingRight: "1.25rem",
        paddingLeft: "2.5rem",
        "@media (min-width: 1024px)": {
            paddingLeft: "3.5rem",
            paddingRight: "3.5rem",
            paddingTop: "10rem",
            paddingBottom: "10rem"
        }
    },
    accordionWrap: {
        "@media (min-width: 1024px)": {
            paddingRight: "1.75rem",
            width: "50%"
        }
    },
    buttonWrap: {
        display: "flex",
        marginTop: "2.5rem",
        "@media (min-width: 1024px)": {
            marginTop: "3rem"
        }
    },
    contentWrap: {
        position: "relative",
        marginBottom: "2rem",
        height: "100%",
        "@media (min-width: 1024px)": {
            paddingLeft: "0.5rem",
            marginBottom: "0",
            marginRight: "5rem",
            width: "45%"
        }
    },
    dotPattern: {
        display: "none",
        position: "absolute",
        top: "-3rem",
        left: "-4rem",
        width: "100%",
        height: "100%",
        "@media (min-width: 1024px)": {
            display: "block"
        }
    },
    image: {
        objectFit: "scale-down",
        objectPosition: "center",
        "@media (min-width: 1024px)": {
            maxHeight: "100%",
        }
    },
    imageWrapper: {

        top: "0",
        "@media (min-width: 768px)": {
            maxWidth: "28rem"
        },
        "@media (min-width: 1024px)": {
            position: "absolute",
            width: "100%",
            maxWidth: "none",
            height: "100%"
        },
        img: {
            objectFit: "contain !important",
            objectPosition: "center",
        }
    }
};


export const query = graphql`
  fragment MediacontentFaqsData on CmsPageBuilderBlocks {
    mediacontent_faqs {
      mediacontent {
        content
        disable_background_dots
        image {
          filename
          title
          description
          url
          contentStackAsset(width: 1440)
        }
      }
      faqs {
        heading
        questions {
          questions {
            question
            answer
          }
        }
        link {
          href
          title
        }
      }
    }
  }
`;

export default MediacontentFaqs;
